import { useState } from "react"

const ReportItem = (props:any) => {
   
  const {stats, type} = props
  const [vitalCount,setVitalCount] = useState(5)

    return(
        <div className="p-4 " >  
            <div className="my-2" >
                <div className="mb-4">
                    <div className="flex justify-between">
                        <p>{type}</p>
                        <p className="cursor-pointer text-light_grey_text" >Download</p>
                    </div>
                    <div className="bg-[#fff] p-4 w-full overflow-hidden my-4 rounded-lg table-auto" >
                        <table className="w-full table-auto " >
                            <thead>
                                <tr>
                                <td className="w-1/6">Date</td>
                                <td className="w-1/6">Value</td>
                                <td className="w-2/6">Interpretation</td>
                                <td className="w-2/6">Description</td>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    stats.slice(0,vitalCount).map((stat:any) => (
                                          <tr key={stat._id} >
                                            <td className="px-2 text-light_grey_text py-4" >{new Date(stat.created_at).toDateString()}</td>
                                            <td className="px-2 text-light_grey_text" >{stat.value }</td>
                                            <td className="px-2 text-light_grey_text" >{stat.interpretation} </td>
                                            <td className="px-2 text-light_grey_text overflow-ellipsis" >{stat.description} </td>
                                            <td></td>
                                        </tr>
                                    ))
                                }
                            </tbody>
                        </table>
                            {stats.length > 10 ? <span className="underline text-secondary cursor-pointer" onClick={()=>setVitalCount(vitalCount + 2)}>See More</span> : null }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ReportItem
